(function () {
  function getJudgeMeToken(root) {
    var section = root.closest("[data-contraband-reviews]");
    if (section && section.dataset.judgemeToken) return section.dataset.judgemeToken;

    var settings = window.jdgmSettings || window.judgemeSettings;
    if (settings) {
      return settings.api_token || settings.public_token || settings.shop_token || "";
    }

    if (window.jdgm) {
      return window.jdgm.apiToken || window.jdgm.publicToken || window.jdgm.token || "";
    }

    return "";
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, ms);
    });
  }

  function waitForJudgeMeToken(attempt) {
    var token = getJudgeMeToken(document.body);
    if (token) return Promise.resolve(token);
    if ((attempt || 0) >= 40) return Promise.resolve("");
    return wait(150).then(function () {
      return waitForJudgeMeToken((attempt || 0) + 1);
    });
  }

  function badgeHasContent(badge) {
    if (!badge) return false;
    return Boolean(
      badge.querySelector(".jdgm-prev-badge__stars, .jdgm-prev-badge__text, .jdgm-star") ||
        badge.textContent.trim()
    );
  }

  function hideFallbacks(root) {
    root.classList.add("has-jdgm-badge");
    root.querySelectorAll("[data-reviews-summary], [data-reviews-empty]").forEach(function (el) {
      el.hidden = true;
    });
  }

  function getReviewsTarget() {
    return document.querySelector(".contraband-reviews__inner") || document.getElementById("product-reviews");
  }

  function scrollToReviews(event) {
    var target = getReviewsTarget();
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function bindReviewsScroll(root) {
    if (root.dataset.reviewsScrollBound === "true") return;
    root.dataset.reviewsScrollBound = "true";

    if (root.tagName !== "A" && root.tagName !== "BUTTON") {
      root.setAttribute("role", "button");
      root.setAttribute("tabindex", "0");
      if (!root.getAttribute("aria-label")) {
        root.setAttribute("aria-label", "View customer reviews");
      }
    }

    root.addEventListener("click", scrollToReviews);
    root.addEventListener("keydown", function (event) {
      if (event.key !== "Enter" && event.key !== " ") return;
      scrollToReviews(event);
    });
  }

  function linkBadgeToReviews(root) {
    root.querySelectorAll("a[href='#product-reviews']").forEach(function (link) {
      link.setAttribute("href", "#product-reviews");
    });
  }

  async function fetchPreviewBadge(root) {
    var badge = root.querySelector(".jdgm-preview-badge");
    if (!badge || badgeHasContent(badge)) return;

    var shopDomain = root.dataset.shopDomain;
    var productId = root.dataset.productId;
    if (!shopDomain || !productId) return;

    var token = await waitForJudgeMeToken(0);
    if (!token) return;

    var url =
      "https://judge.me/api/v1/widgets/preview_badge?shop_domain=" +
      encodeURIComponent(shopDomain) +
      "&api_token=" +
      encodeURIComponent(token) +
      "&external_id=" +
      encodeURIComponent(productId);

    try {
      var res = await fetch(url);
      if (!res.ok) return;

      var data = await res.json();
      if (!data || !data.widget) return;

      badge.innerHTML = data.widget;
      if (typeof window.jdgm !== "undefined" && typeof window.jdgm.customizeBadges === "function") {
        window.jdgm.customizeBadges();
      }
    } catch (err) {
      /* ignore */
    }
  }

  async function initBadge(root) {
    linkBadgeToReviews(root);

    var badge = root.querySelector(".jdgm-preview-badge");
    for (var i = 0; i < 50; i += 1) {
      if (badgeHasContent(badge)) {
        hideFallbacks(root);
        linkBadgeToReviews(root);
        return;
      }
      await wait(150);
    }

    await fetchPreviewBadge(root);

    if (badgeHasContent(badge)) {
      hideFallbacks(root);
      linkBadgeToReviews(root);
    }
  }

  function init() {
    document.querySelectorAll(".product__reviews").forEach(function (root) {
      bindReviewsScroll(root);
    });
    document.querySelectorAll("[data-product-reviews-badge]").forEach(initBadge);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
})();
